














import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import InfoDialog from '@/modules/common/dialog/components/shared/InfoDialog.vue'
import { Prop } from 'vue-property-decorator'
import { ProfitCollectionModel, ProfitCollectionWithModel } from '@/modules/profit/models/profit-collection.model'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import { ProfitType } from '@/modules/profit/models/profit-resource.model'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import MessageBox from '@/modules/shared/components/shared/MessageBox.vue'

@Component({
  components: {
    BaseButton
  }
})
export default class AdminProfitIndexPageTableActions extends Vue {
  @Prop({ required: true }) profitResource: ProfitCollectionModel
  @Prop({ required: true }) profitFixedData: ProfitCollectionWithModel

  private profitInfoItems: InfoDialog['items'] = [
    {
      name: 'amount',
      label: 'مقدار',
      value: this.profitResource.amount.toLocaleString()
    },
    {
      name: 'type',
      label: 'نوع سود',
      value: this.profitFixedData.types[this.profitResource.type],
      valueClasses: this.profitResource.type === ProfitType.INCREASE ? 'text-tes-green' : 'text-tes-red'
    },
    {
      name: 'profitable_type',
      label: 'مدل سود',
      value: this.profitFixedData.profitable_types[this.profitResource.profitable_type]
    },
    {
      name: 'profitable_id',
      label: 'شماره مدل',
      value: this.profitResource.profitable_id || ''
    },
    {
      name: 'owner',
      label: 'ایجاد کننده',
      value: {
        component: AdminUserInfoButton,
        props: { basicUser: this.profitResource.owner, asText: true }
      }
    },
    {
      name: 'created_at',
      label: 'تاریخ ایجاد',
      value: {
        component: DateTooltipped,
        props: {
          isoDate: this.profitResource.created_at
        }
      }
    },
    {
      name: 'description',
      label: '',
      value: '',
      rowComponent: {
        component: MessageBox,
        props: {
          message: this.profitResource.description,
          class: 'bg-tes-grey text-tes-navy-blue-darker'
        }
      }
    }
  ]

  private openProfitInfoDialog() {
    this.$q.dialog({
      component: InfoDialog,
      items: this.profitInfoItems,
      header: 'اطلاعات آیتم سود'
    })
  }
}
